import type { LucideIcon } from "lucide-react";
import {
  Bath,
  CircleEllipsis,
  Droplets,
  Dumbbell,
  Eye,
  Gem,
  Hand,
  Leaf,
  Palette,
  PawPrint,
  PenTool,
  Scissors,
  ScissorsLineDashed,
  Shapes,
  SprayCan,
  Zap,
} from "lucide-react";

const CATEGORY_ICONS: Record<string, LucideIcon> = {
  hair_salon: Scissors,
  barbershop: ScissorsLineDashed,
  nail_salon: Gem,
  beauty_salon: Palette,
  spa: Bath,
  massage: Hand,
  skin_care: Droplets,
  eyebrows_lashes: Eye,
  tattoo_piercing: PenTool,
  hair_removal: Zap,
  wellness: Leaf,
  fitness: Dumbbell,
  pet_grooming: PawPrint,
  other: Shapes,
  makeup: SprayCan,
};

function getCategoryIcon(key: string): LucideIcon {
  return CATEGORY_ICONS[key] ?? CircleEllipsis;
}

export { getCategoryIcon };
